// removed by extract-text-webpack-plugin
module.exports = {"form":"form__1u_8-","forgot-password-link":"forgot-password-link__3flFn"};


//////////////////
// WEBPACK FOOTER
// ./app/scripts/views/App/views/Login/styles.scss
// module id = ./app/scripts/views/App/views/Login/styles.scss
// module chunks = 1